<template>
<div>

  <div class='gPageBorder' v-loading='gloading'>
    <div style='width:calc(100% - 24px);height:100%;background: none;padding-left:24px;padding-bottom:24px;'>
      <div style='height:64px;'>
        <button class='dt-word-main' style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{$t('app_developer')}}ID</button>
      </div>
      <div style='height:44px;'>
        <table  style='width:100%;'>
          <tr style=''>
            <td style=''>
              <p class='dt-word-title' style="display:inline-block;width:80px;">AppKey：</p>
              <label class='dt-word-main'>{{keyInfo? keyInfo.key : ''}}</label>
            </td>
           
          </tr>
          <br/>
          <tr >
            <td style="width:100%">
              <p class='dt-word-title' style="display:inline-block;width:80px;">AppSecret：</p>
              <label v-show='isShowSec' class='dt-word-main'>{{keyInfo? keyInfo.secret : ''}}&nbsp;&nbsp;&nbsp;&nbsp;</label>

              <label @click="showclick" style="color:#58B7FF;cursor:pointer;">{{showkeylb}}</label> &nbsp;/&nbsp;
              <label @click="generateKey" style="color:#58B7FF;cursor:pointer;padding-right:12px;">{{$t('app_reset')}}</label>
            </td>
            
          </tr>
          
        </table>
      </div>

    </div>
  </div>

  <div id='' class='gPageBorder gTopMg' v-loading='loading'>

    <tyc :tqobj='tqobj'></tyc>

    <div id=''>
      <div style=''>

        <el-row>
          <el-col :span="12" class=''>
            <el-button class='gSgLeftBtn' type='primary' @click='jumpToUpload'>{{$t('app_addpsg')}}</el-button>
          </el-col>

          <el-col :span="4">
            <div class='gCtrl'>
              <el-select  v-model="selectMid"  :placeholder="$t('app_type')" @change='selectChange'>
                <el-option
                  v-for="item in authSts"
                  :key="item.vl"
                  :label="item.lb"
                  :value="item.vl">
                </el-option>
              </el-select>
            </div>
          </el-col>

          <el-col :span="4">
            <div class='gCtrl'>
              
              <MechanismSelector style='' :data="mechanismData"></MechanismSelector>
            </div>
          </el-col>
            

          <el-col :span="4">
            <div class='gSideCtrl'>
              <el-input  :placeholder="$t('app_name')" v-model='queryKey' @keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
            </div>
          </el-col>

        </el-row>
        
        
      </div>
    </div>

    <div id=''>
      <el-table
        @row-click='cellClick'
        :data="tableData"
        border
        class='tbPoint gTopMg'
        style="width: 100%;border:none;">
        
        <el-table-column
          header-align='center'
          align='center'
          prop="appname"
          :label="$t('app_psgname')"
          width="">
        </el-table-column>
        
        <el-table-column
          header-align='center'
          align='center'
          prop="merchantName"
          width=''
          :label="$t('app_distributor')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="status"
          width='115'
          :label="$t('app_authstat')">
          <template slot-scope='scope'>
            <!-- <label :style='getStatus(scope.row.status).style'>{{getStatus(scope.row.status).vl}}</label> -->
            <!-- opst -->
            <tagc :tagobj="{type: 'openAuthType', vl: scope.row.isauthen+''}"></tagc>
          </template>
        </el-table-column>

       

        <el-table-column
          header-align='center'
          align='center'
          prop="createTime"
          width='175'
          fformatter="dateFormat"
          :label="$t('app_addtime')">
        </el-table-column>
        
        <el-table-column
          header-align='center'
          align='right'
          prop="operate"
          width='122'
          :label="$t('app_operate')">
          <template slot-scope='scope'>     

            <!-- <el-button v-show="(scope.row.status !== '1' && scope.row.status !== '2') && scope.row.isoperate === 0" type=text @click='editApp(scope.row)'>{{$t('app_edit')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_edit')" placement="top">
              <el-button  type=text @click='editApp(scope.row)'><i class="fa fa-pencil" style=""></i></el-button>
            </el-tooltip>


            <!-- <el-button v-show='scope.row.isoperate === 0' type=text @click='deleteApp(scope.row)'>{{$t('app_del')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
              <el-button type='text' @click='deleteApp(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip>
            
            
          </template>
        </el-table-column>
      </el-table>

      <div class="gPgDiv" style=''>
        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="$gRow"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</div>
</template>

<style>
  /* html,body{width:100%;height:100%;}*/

  .tbPoint td{cursor:pointer}

  .cmMarginFrame{width:calc(100% - 20px);height:100%;background:none;margin-left:10px;}

  #appDepot{min-width:840px;}

  #adData{}

  
    
</style>

<script>
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import mm from 'moment'
  import tagc from '@/components/global/tagc.vue'
  import tyc from '@/components/global/tyc.vue'
  export default{
    components: {
      MechanismSelector,tagc,tyc
    },
    data () {
      var that = this
      return {
        isShowSec: false,
        mechanismData: {
          callback (value) {
            that.mech = value
            that.getList()
          }
        },
        gloading: false,
        keyInfo: '',
        listKey: 'launch-list',
        cerDialogVisible: false,
        cerTipDialogVisible: false,
        dvLoading: 0,
        appId: '',
        tqobj: '',
        authSts: [],
        stModel: [
          {label: this.$t('app_online'), vl: '1'},
          {label: this.$t('app_offline'), vl: '2'},
          {label: this.$t('app_new'), vl: '0'}
        ],
        channels: [],
        mech: '',
        srchValue: '',
        channelId: '',
        cerTipMsg: '',
        status: '',
        dvIndex: 1,
        dialogVisible: 0,
        mechanismId: window.localStorage['mechanismId'],
        selectMid: '',
        tableData: [],
        dvTableData: [],
        appTypes: [],
        appTypeValue: '',
        appStatus: [
          {label: this.$t('app_prePushVerify'), value: '0'},
          {label: this.$t('app_preVerify'), value: '1'},
          {label: this.$t('app_verifyPass'), value: '2'},
          {label: this.$t('app_verifyNotPass'), value: '3'}],
        appStatusValue: '',
        total: 0,
        dvTotal: 0,
        loading: 0,
        appType: '',
        queryKey: ''
      }
    },
    computed: {
      showkeylb () {
        if (this.isShowSec) {
          return this.$t('app_hide')
        } else {
          return this.$t('app_view')
        }
      },
      index () {
        var vl = this.$getWPage(this.listKey)
        return vl ? vl : 1
      },
      getDvStatus (value) {
        switch (value) {
          case '0':
            return this.$t('app_prePushVerify')
          case '1':
            return this.$t('app_preVerify')
          case '2':
            return this.$t('app_verifyPass')
          case '3':
            return this.$t('app_verifyNotPass')
        }
      }
    },
    methods: {
      showclick () {
        this.isShowSec = !this.isShowSec
      },
      generateKey () {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_gentip'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.gloading = 1
          var id = localStorage.userId
          this.$generateKey(id, (res) => { 
            this.gloading = 0
            var secret = res.data
            this.$setWObj('keyInfo', {key: this.keyInfo.key, secret: secret})
            this.keyInfo.secret = secret
            this.$message(res.message)
          }, () => {
            this.gloading = 0
            this.$message.error(this.$t('app_rqsError'))
          })
        }, '')
      },
      pushCreateCer () {
        this.$router.push({path: "/certificate/new"})
      },
      pushUploadCer () {
        this.$router.push({path: "/certificate/upload"})
      },
      bindOperate (row) {
        //console.log(row)
        
        this.dvLoading = 1
        if (this.$appUrlTag === 0) {
          this.$bindApp('0', row.terminalNo, this.appId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.dvLoading = 0
          }, () => {
            // error
            this.dvLoading = 0
          })
        } else {
          // console.log(localStorage.mechanismId, tNo)
          this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.dvLoading = 0
          }, () => {
            // error
            this.dvLoading = 0
          })
        }
      },
      getChannels () {
        this.$getChannelList(10000, 1, '', '' , '', (res) => {
          if (res.status === 200) {
            this.channels = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      getStatus (value) {
        if (!value) return ''
        switch (value) {
          case '0':
            return {vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'}
          case '1':
            return {vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'}
          case '2':
            return {vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'}
          case '3':
            return {vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'}
        }
      },
      srchDevice () {
        this.getDevices()
      },
      selectDvChange (vl) {
        this.getDevices()
      },
      pageDvSized (val) {
        this.$gRow = val
        this.getDevices()
      },
      getDevices () {
        var vl = this.srchValue ? this.srchValue : ''
        var channel = this.channelId ? this.channelId : ''
        var status = this.status ? this.status : ''
        var appId = this.appId ? this.appId : ''
        this.dvLoading = 1
        if (this.$appUrlTag === 0) {
          this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, (res) => {
            // console.log('dv', res)
            this.dvLoading = 0
            if (res.data) {
              this.dvTableData = res.data
              this.dvTotal = res.total
            }
          }, () => {
            // error
            this.dvLoading = 0
          })
        } else {
          
          this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, (res) => {
            console.log('dv', res)
            this.dvLoading = 0
            if (res.data) {
              this.dvTableData = res.data
              this.dvTotal = res.total
            }
          }, () => {
            // error
            this.dvLoading = 0
          })
        }
        
      },
      editApp (row) {
        
        this.$setWObj('passageEdit', row.appid)
        this.$router.push({path: '/openpl/passage/edit'})
      },
      pushApp (row) {
        
        //this.$setWObj('launcherPush', row)
        //this.$router.push({path: '/launch-push'})

        this.$setWObj('pushList', {type: '10', data: row})
        this.$router.push({path: '/launch-push'})
       
      },
      query () {
        this.getList()
      },
      selectChange (vl) {
        this.selectMid = vl
        this.getList()
      },
      reset () {
        this.queryKey = ''
        this.appType = ''
        this.getList()
      },
      pageSelect (index) {
        this.$setWPage(this.listKey, index)
        this.getList()
      },
      pageDvSelect (index) {
        this.dvIndex = index
        this.getDevices()
      },
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
      deleteApp (obj) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          
          this.$delPassage(obj.appid, (res) => {
            if (res.code === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, '')
        }, '')
      },
      submitApp (obj) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          this.$submitLauncher(obj.launcherid, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
          })
          
        }, '')
      },
      cellClick (row, ev, col) {

        

        if (col.label && col.label === this.$t('app_operate')) {
          return
        }
      
        //console.log(row)

        this.$setWObj('passageEdit', row.appid)
        this.$router.push({path: '/openpl/passage/detail'})
        
      },
      jumpToUpload () {
        /*this.loading = 1
        this.$isCer(this.mechanismId, (res) => {
          this.loading = 0
          // console.log('cer', res)
          if (!res.data) {
            this.$setWObj('editAppConfig', {type: 0})
            //this.$router.push({name: this.$t('menu.appManageSub.uploadApp')})
          } else {
            //this.$message.error(res.message)
            //this.$router.push({path: "/certificate/new"})
            this.cerTipMsg = res.message
            var vl = localStorage.cerType
            if (vl === '0') {
              // self
              this.cerDialogVisible = true
            } else {
              // other
              this.cerTipDialogVisible = true
            }
            
          }
        }, () => {
          // this.$message(this.$t('app_rqsError'))
        })*/

        this.$setWObj('passageEdit', '')
        this.$router.push({path: '/openpl/passage/add'})
      },
      getList () {
        this.loading = 1
        var isauth = this.selectMid ? this.selectMid : '' //渠道商id
        var name = this.queryKey ? this.queryKey : ''
        var mech = this.mech


        this.$passageList(this.index, this.$gRow, name, isauth, mech, (res) => { 
          this.loading = 0
          if (res.code === 200) {
            this.total = res.total
            this.tableData = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD HH:mm:ss')
      },
      setInstallType (type) {
        return this.$installType[type]
      }
    },
    mounted () {
      this.tqobj = {
        keys: ['openplAuths'],
        callback: (data) => {
          this.authSts = data[0]
        }
      }
      //this.getChannels()
      this.getList()
      /*this.$getAppTypeList(100000000, 1, (res) => {
        if (res.status === 200) {
          this.appTypes = res.data
        } else {
          this.$message(res.message)
        }
      }, '')*/
     
      this.keyInfo = this.$getWObj().keyInfo

      // (localStorage.userId)
    },
    destroyed () {
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?cb0f1b28